import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '@/api/client';
import { useAuth } from '@/context/AuthContext';
import Logo from '@/components/Logo';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Idempotent guard
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setError('No session_id received from Google.');
      return;
    }
    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        await refresh();
        const profile = data.profile;
        // Clear hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        if (profile.status === 'approved') {
          navigate('/member/dashboard', { state: { user: profile } });
        } else {
          navigate('/pending-approval', { state: { user: profile } });
        }
      } catch (e) {
        setError(e.response?.data?.detail || 'Sign-in failed. Please try again.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-moj-cream flex items-center justify-center px-4">
      <div className="card-moj p-10 max-w-md w-full text-center">
        <div className="flex justify-center mb-4"><Logo size="lg" showText={false}/></div>
        {error ? (
          <>
            <h2 className="font-serif text-2xl text-red-700 mb-2">Sign-in error</h2>
            <p className="text-moj-charcoal">{error}</p>
            <button onClick={() => navigate('/login')} className="btn-primary mt-6">Try again</button>
          </>
        ) : (
          <>
            <h2 className="font-serif text-2xl text-moj-purple-deep mb-2">Signing you in…</h2>
            <p className="text-moj-charcoal/70">Please wait while we welcome you to Ministry of Jesus.</p>
            <div className="w-12 h-12 border-4 border-moj-purple border-t-moj-gold rounded-full animate-spin mx-auto mt-6"></div>
          </>
        )}
      </div>
    </div>
  );
}
